// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FlexRow_wrapper__NFjv3"};